import { useTranslation } from "react-i18next";

import { Modal } from "@pentabd/ui";

import { SectionTitle } from "./SectionTitle";
import { SelectEmployeeForm } from "./SelectEmployeeForm";

interface SelectEmployeeModalProps {
  isOpen: boolean;
  onClose: () => void;
  action: (arg: any) => void;
  registeredName: string;
  isLoading?: boolean;
}

export const SelectEmployeeModal = ({
  isOpen,
  onClose,
  action,
  registeredName,
  isLoading,
}: SelectEmployeeModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal overlay isOpen={isOpen} onClose={onClose} closeAble>
      <div className="p-10">
        <SectionTitle label={t("EMPLOYEE.SELECT_EMPLOYEE.TITLE")} />
        <SelectEmployeeForm
          registeredName={registeredName}
          action={action}
          isLoading={isLoading}
        />
      </div>
    </Modal>
  );
};
